import React from 'react';
import PropTypes from 'prop-types';
import { ClassName, ToggleButton } from "mgUiKit";

class SwitchTheme extends  React.Component {
    constructor(props, context) {
        super(props);
        this.state = {
            checked : this.props.on
        }
      
        this.mqDark = window.matchMedia("(prefers-color-scheme: dark)");
        this.wrapperScommesse = document.getElementsByClassName("mg-scommesse-mainWrapper");
        this.bodyElement = document.getElementsByTagName("body")[0];
    }

    componentDidMount() {
        this.manageTheme();
        this.mqDark.addListener(function(){
            this.manageTheme();
        }.bind(this));
    }   

    addClassWrapper(className){
        this.bodyElement.classList.add(className);
        if(this.wrapperScommesse != null  && this.wrapperScommesse.length > 0){
            this.wrapperScommesse[0].classList.add(className);
        }
    }
    removeClassWrapper(className){
        this.bodyElement.classList.remove(className);
        if(this.wrapperScommesse != null && this.wrapperScommesse.length > 0){
            this.wrapperScommesse[0].classList.remove(className);
        }
    }

    handleSwitchTheme() {
        var newState = !this.state.checked;
        // Dark
        if(!newState){
            localStorage.setItem("mg-theme", "dark");
            this.manageTheme("dark");
        }
        else{
            localStorage.setItem("mg-theme", "light");
            this.manageTheme("light");
            //
        }
        
    }

    manageTheme(forceLayout){
        var _themeSetted = "";
        if(forceLayout == "dark"){
            this.addClassWrapper("dark");
            this.removeClassWrapper("light");
            _themeSetted = "dark";
        }
        else if(forceLayout == "light"){
            this.addClassWrapper("light");
            this.removeClassWrapper("dark");
            _themeSetted = "light";
            }
        else{    
            _themeSetted = localStorage.getItem("mg-theme");
            //priorità al sistema operativo in modalità dark
            if(this.mqDark.matches){
                _themeSetted = "dark"
                this.addClassWrapper("dark");
                this.removeClassWrapper("light");    
            }
            else{
                if (_themeSetted == "dark") {
                    this.addClassWrapper("dark");
                    this.removeClassWrapper("light");
                    _themeSetted = "dark";
                }
                else{
                    this.addClassWrapper("light");
                    this.removeClassWrapper("dark");
                    _themeSetted = "light";
                }
            }
        }

        this.bodyElement.setAttribute('data-theme', _themeSetted);

        this.setState({
            checked: _themeSetted == 'light'
        });
        this.props.callBack(_themeSetted);
    }

    render() {
        if(this.props.mode == 'listner'){
            return null;
        }
        var switchThemeAttribute = {
            OnClick: this.handleSwitchTheme.bind(this),
            on: this.state.checked,
            small: this.props.small,
            classNames: this.props.classNames,
            icons:{
                on: "fa-sun-o",
                off: "fa-moon-o"
            }
        };
        return (
            <>
            <ToggleButton {...switchThemeAttribute}/>
            </>
            );
    }
}

SwitchTheme.propTypes = {
    small: PropTypes.bool,
    on: PropTypes.bool,
    classNames: PropTypes.string,
    callBack: PropTypes.func,
    mode: PropTypes.oneOf(['render', 'listner']),
};

SwitchTheme.defaultProps = {
    small: false,
    classNames: "",
    on: false,
    callBack: (theme) => {},
    mode: "render"
};

export default SwitchTheme;


/*
<script>

$j(document).ready(function () {

  
  
    var _wrapSelector = $j("body,.mg-scommesse-mainWrapper");
    var _switchButton = $j("#mg-switch-theme");
    var mqDark = window.matchMedia("(prefers-color-scheme: dark)");
  
   
  

    manageTheme(mqDark);  
   
    //Pulsante di switch
    _switchButton.click(function () {
        if (_switchButton.attr("checked")) {
            localStorage.setItem("mg-theme", "light");
          manageTheme(mqDark, "light");

        } else {

            localStorage.setItem("mg-theme", "dark");
          manageTheme(mqDark, "dark");
        }
      
       
    });
  
  
   //listener media query
   mqDark.addListener(function(){
     manageTheme(mqDark);
   });
  
  
  function manageTheme(mqDark, forceLayout){
    
    
    if(forceLayout == "dark"){
      _wrapSelector.removeClass("light").addClass("dark");
      }
    else if(forceLayout == "light"){
      _wrapSelector.removeClass("dark").addClass("light");
      }
    else{    
    var _themeStorage = localStorage.getItem("mg-theme");
       //priorità al sistema operativo in modalità dark
   if(mqDark.matches){
      _themeStorage = "dark"
      _wrapSelector.removeClass("light").addClass("dark");
      _switchButton.attr('checked', false);    
      
   }
   else{
      if (_themeStorage == "dark") {
          _wrapSelector.removeClass("light").addClass("dark");
          _switchButton.attr('checked', false);
      }
      else{
        _wrapSelector.removeClass("dark").addClass("light");
          _switchButton.attr('checked', true);
      }
   }
    }
    
    
    switchUserBox(_themeStorage != undefined ? _themeStorage : forceLayout);
    
    
  }
  
  function switchUserBox(_themeStorage) {
    if (typeof window.UserBoxAppComponent != "undefined") {
        if (_themeStorage == "light") {
            window.UserBoxAppComponent.switchToThemeLight();
        }
        else {
            window.UserBoxAppComponent.switchToThemeDark();
        }
    }
    else {
        setTimeout(function () {
            switchUserBox(_themeStorage);
        }, 1000);
    }
  }
}); 
   
</script>



*/